import { render, staticRenderFns } from "./Equipamentos.vue?vue&type=template&id=69052240&scoped=true"
import script from "./Equipamentos.vue?vue&type=script&lang=js"
export * from "./Equipamentos.vue?vue&type=script&lang=js"
import style0 from "./Equipamentos.vue?vue&type=style&index=0&id=69052240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69052240",
  null
  
)

export default component.exports